import apiClient from "./client";
import type {
  AsyncTasksListResponse,
  GetAsyncTasksParams,
} from "../types/async-task";

export const getAsyncTasks = async (
  params: GetAsyncTasksParams
): Promise<AsyncTasksListResponse> => {
  const { data } = await apiClient.get<AsyncTasksListResponse>("/async_tasks", {
    params: {
      kind: params.kind,
      stat: params.stat,
      order: params.order,
      sort: params.sort,
      page: params.page,
      limit: params.limit,
    },
  });
  return data;
};
